/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */

import React, { Component } from 'react';

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import { connect } from 'react-redux';
import { urls } from '../utils/constants';

const mapStateToProps = (state) => ({ roles: state.roles });

class ConnectedSecondaryList extends Component {
  render() {
    return (
      <div>
        <ListItem component="a" href={urls.logout.path}>
          <ListItemIcon>
            <ExitToAppIcon />
          </ListItemIcon>
          <ListItemText primary="Sair" />
        </ListItem>
      </div>
    );
  }
}

const SecondaryListItems = connect(mapStateToProps)(ConnectedSecondaryList);
export default SecondaryListItems;
